import React, { useContext, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { RootStoreContext } from "../../../../../app/stores/rootStore";

const SharedTemplates = ({ projectId }) => {
  const navigate = useNavigate();
  const { screeningStore } = useContext(RootStoreContext);
  const { sharedTemplates, loadingWorkflows, fetchWorkflows } = screeningStore;

  useEffect(() => {
    fetchWorkflows(projectId);
  }, [projectId, fetchWorkflows]);

  const [filter, setFilter] = React.useState("all");

  return (
    <div className="fadein animation-duration-500" style={{ display: "flex", flexDirection: "column", flex: 1 }}>
      <div className="screening-header">
        <span className="screening-header-icon">🌐</span>
        <span className="screening-header-title">Shared Templates</span>
      </div>

      <div className="screening-body">
        {/* Filter pills */}
        <div className="flex gap-2" style={{ marginBottom: 16 }}>
          {["all", "recent"].map((f) => (
            <div
              key={f}
              onClick={() => setFilter(f)}
              className={`screening-filter-pill ${filter === f ? "active" : "inactive"}`}
            >
              {f === "all" ? `All (${sharedTemplates.length})` : "Recently Updated"}
            </div>
          ))}
        </div>

        {loadingWorkflows ? (
          <div className="screening-empty">
            <div className="screening-empty-text">Loading...</div>
          </div>
        ) : sharedTemplates.length === 0 ? (
          <div className="screening-empty">
            <div className="screening-empty-icon">🌐</div>
            <div className="screening-empty-text">No shared templates yet</div>
            <div className="screening-empty-sub">Templates shared by your team will appear here</div>
          </div>
        ) : (
          <div className="screening-template-grid">
            {sharedTemplates.map((t, i) => (
              <div key={t.id || i} className="screening-template-card">
                <div className="screening-template-name">📄 {t.name}</div>
                <div className="screening-template-meta">
                  Nodes: {t.nodeCount} · Used: {t.useCount} times · By: {t.createdBy || "Unknown"}
                  <br />📅 {new Date(t.lastEditAt).toLocaleDateString()}
                </div>
                <div className="screening-template-actions">
                  <Button label="Use" icon="pi pi-play" className="p-button-sm"
                    onClick={() => navigate(`editor/${t.id}`)}
                    style={{ background: "#4f46e5", border: "none", borderRadius: 4, fontSize: "0.8rem" }} />
                  <Button label="Details" icon="pi pi-info-circle" className="p-button-sm p-button-text"
                    style={{ borderRadius: 4, fontSize: "0.8rem" }} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(SharedTemplates);
